import { createSubtemplate } from "@repo/design-system/lib/client-registry";
import type { SectionKey } from "~/components/job-page/jobpagetemplate/unified-jobpage-template";
import CompanyControlsolutions from "~/components/job-page/subclients/controlsolutions/company-controlsolutions";
import ApplicationProcessMailFirstEon from "~/components/job-page/subclients/shared/application-process-mail-first-eon";
import JobAdTemplateControlsolutions from "~/components/job-page/subclients/shared/jobad-template-manual-job";

export const defaultControlsolutions = createSubtemplate<SectionKey>({
  name: "controlsolutions",
  trigger: () => true,
  showProd: true,
  config: {
    overrides: {
      companyInfo: CompanyControlsolutions,
      jobDescription: JobAdTemplateControlsolutions,
      applicationProcess: ApplicationProcessMailFirstEon,
    },
    sections: [
      "stickyContact",
      "headerImage",
      "breadcrumb",
      "companyInfo",
      "jobDescription",
      "contact",
      "applicationProcess",
      "diversity",
      "about",
      "benefits",
      "similarJobs",
      "printView",
    ],
  },
});
